import React from "react";
import styled from "styled-components";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";

type ModalReusableProp = {
  variant: "error" | "success" | "none";
  heading: string;
  subHeading?: string;
  buttonLabel: string;
  setOpenOrClose: (a: boolean) => void;
  onSubmit: () => void;
};
type styledProp = {
  subHeadingExists: string | null;
};
const ErrorSuccessModal = ({
  variant,
  heading,
  subHeading,
  buttonLabel,
  setOpenOrClose,
  onSubmit,
}: ModalReusableProp) => {
  return (
    <Modal variant={variant} width="28rem" setOpenOrClose={setOpenOrClose}>
      <ModalReusableStyled>
        <ModalReusableHeader subHeadingExists={subHeading || null}>
          {heading}
        </ModalReusableHeader>
        <ModalReusableSubHeader subHeadingExists={subHeading || null}>
          {subHeading}
        </ModalReusableSubHeader>
        <ButtonWrapper subHeadingExists={subHeading || null}>
          <Button label={buttonLabel} size="medium" onClick={onSubmit} />
        </ButtonWrapper>
      </ModalReusableStyled>
    </Modal>
  );
};

export default ErrorSuccessModal;

const ModalReusableStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const ModalReusableHeader = styled.div<styledProp>`
  font-family: "Poppins-Medium";
  font-size: 1.25rem;
  color: ${Colors.mineShaft};
  margin-top: ${(props) => (props.subHeadingExists ? "3.9rem" : "5.5rem")};
`;
const ModalReusableSubHeader = styled.div<styledProp>`
  font-family: "Poppins-Book";
  font-size: 1.25rem;
  color: ${Colors.mineShaft};
  width: 20rem;
  margin-top: ${(props) => (props.subHeadingExists ? "0.9rem" : "0")};
`;
const ButtonWrapper = styled.div<styledProp>`
  margin-top: ${(props) => (props.subHeadingExists ? "2rem" : "3rem")};
  width: 9.7rem;
  height: 3rem;
  margin-bottom: ${(props) => (props.subHeadingExists ? "3rem" : "3.75rem")};
`;
